var ACTIONS;

(function (ACTIONS) {
  ACTIONS[ACTIONS["REGISTER_HOST"] = 0] = "REGISTER_HOST";
  ACTIONS[ACTIONS["DEREGISTER_HOST"] = 1] = "DEREGISTER_HOST";
  ACTIONS[ACTIONS["ADD_UPDATE_PORTAL"] = 2] = "ADD_UPDATE_PORTAL";
  ACTIONS[ACTIONS["REMOVE_PORTAL"] = 3] = "REMOVE_PORTAL";
})(ACTIONS || (ACTIONS = {}));

const INITIAL_STATE = {};
export { ACTIONS, INITIAL_STATE };
//# sourceMappingURL=constants.js.map